const ValueConstants = {
  BoundingBoxAcceptableScaleValue: 577791


};

export default ValueConstants;
